import CharacterCounter from '@stimulus-components/character-counter';

export default class extends CharacterCounter {
  connect() {
    super.connect();
  }
}
